// components/SideDrawer.tsx
import React from 'react';
import {
  Drawer,
  Box,
  Stack,
  Avatar,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Button
} from '@mui/material';

import CopyrightIcon from '@mui/icons-material/Copyright';
import HomeIcon from '@mui/icons-material/Home';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ArticleIcon from '@mui/icons-material/Article';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import CategoryIcon from '@mui/icons-material/Category';
import EventIcon from '@mui/icons-material/Event';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import PersonIcon from '@mui/icons-material/Person';

interface SideDrawerProps {
  open: boolean;
  onClose: () => void;
  menuItems: { label: string; isActive?: boolean; hasDot?: boolean }[];
}

const SideMenuDrawer = ({ open, onClose, menuItems }: SideDrawerProps) => (
  <Drawer anchor="right" open={open} onClose={onClose}>
    <Box sx={{ width: 300, p: 2 }} role="presentation">
      {/* 로그인 영역 */}
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <Avatar sx={{ bgcolor: '#2196f3' }}>L</Avatar>
        <Typography variant="h6">로그인</Typography>
      </Stack>

      {/* 캐시 충전 알림 */}
      <Box sx={{ backgroundColor: '#e3f2fd', p: 1.5, borderRadius: 2, mb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography sx={{ fontSize: '0.9rem' }}>
            캐시 충전
            <br />
            <strong>평일 20% 적립혜택</strong>을 확인하세요.
          </Typography>
          <CopyrightIcon sx={{ color: 'orange' }} />
        </Stack>
      </Box>

      {/* 마이페이지 / 선물코드 */}
      <List>
        <ListItem button>
          <ListItemIcon><PersonIcon /></ListItemIcon>
          <ListItemText primary="마이페이지" />
        </ListItem>
        <ListItem button>
          <ListItemIcon><CardGiftcardIcon /></ListItemIcon>
          <ListItemText primary="선물코드 등록" />
        </ListItem>
      </List>

      <Divider sx={{ my: 1 }} />

      {/* 주요 메뉴 */}
      {/* <List>
        <ListItem button><ListItemIcon><HomeIcon /></ListItemIcon><ListItemText primary="홈" /></ListItem>
        <ListItem button><ListItemIcon><EmojiEventsIcon /></ListItemIcon><ListItemText primary="랭킹" /></ListItem>
        <ListItem button><ListItemIcon><ArticleIcon /></ListItemIcon><ListItemText primary="매거진" /></ListItem>
        <ListItem button><ListItemIcon><AudiotrackIcon /></ListItemIcon><ListItemText primary="오디오북" /></ListItem>
        <ListItem button><ListItemIcon><CategoryIcon /></ListItemIcon><ListItemText primary="카테고리" /></ListItem>
        <ListItem button><ListItemIcon><EventIcon /></ListItemIcon><ListItemText primary="이벤트" /></ListItem>
      </List> */}
      <List>
        {menuItems.map(({ label, hasDot }) => (
            <ListItem button key={label}>
            <ListItemText
                primary={
                <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                    <Typography>{label}</Typography>
                    {hasDot && (
                    <Box
                        sx={{
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        backgroundColor: 'red',
                        position: 'absolute',
                        top: 6,
                        right: -12,
                        }}
                    />
                    )}
                </Box>
                }
            />
            </ListItem> 
        ))}
    </List>


      {/* 버튼 */}
      <Box mt={2}>
        <Button variant="contained" fullWidth sx={{ borderRadius: 2, fontWeight: 'bold' }}>
          크리에이터스튜디오가기
        </Button>
      </Box>

      {/* 하단 링크 */}
      <Box mt={4}>
        <Typography variant="body2" color="text.secondary">
          공지사항 · 이용약관 · 개인정보처리방침 · 고객센터 · 광고소개 · 불법촬영물 유통 신고
        </Typography>
      </Box>
    </Box>
  </Drawer>
);

export default SideMenuDrawer;
